import { RouteRecordRaw } from 'vue-router';

const teamRoutes: Array<RouteRecordRaw> = [
  {
    path: 'team',
    component: () =>
      import('@/app/team/components/team-list-index-component.vue'),
    name: 'app.team',
  },
];

export default teamRoutes;
